import React from 'react';
import classnames from 'classnames';
import UserAvatar from '../../../../../../User/Avatar';
import UserLink from '../../../../../../User/Link';
import s from './Attribution.scss';
export var Attribution = function (_a) {
    var author = _a.author, showAuthorTooltip = _a.showAuthorTooltip, className = _a.className, _b = _a.avatarSize, avatarSize = _b === void 0 ? 25 : _b, userlinkClassName = _a.userlinkClassName;
    return (React.createElement("div", { className: classnames(s['attribution'], className) }, author && (React.createElement(React.Fragment, null,
        React.createElement(UserAvatar, { size: avatarSize, className: s['avatar'], user: author, withTooltip: showAuthorTooltip, "aria-label": author.username }),
        React.createElement(UserLink, { className: classnames(s['user-link'], userlinkClassName), user: author, withTooltip: showAuthorTooltip, biData: {
                creatorid: author.useridUuid,
            } })))));
};
Attribution.displayName = 'Attribution';
export default Attribution;
//# sourceMappingURL=Attribution.js.map